import { FC, createContext, useContext, ReactNode, useState } from 'react'
import { Draft, DraftRequestReviewAction } from 'backoffice/components/Drafts/types/types'

interface ActionModalState {
  action: DraftRequestReviewAction
  draft: Draft
}

interface ActionModalContextType {
  actionModal: ActionModalState | null
  setActionModal: (modal: ActionModalState | null) => void
}

const ActionModalContext = createContext<ActionModalContextType | undefined>(undefined)

interface ActionModalProviderProps {
  children: ReactNode
}

export const ActionModalProvider: FC<ActionModalProviderProps> = ({ children }) => {
  const [actionModal, setActionModal] = useState<ActionModalState | null>(null)

  return <ActionModalContext.Provider value={{ actionModal, setActionModal }}>{children}</ActionModalContext.Provider>
}

export const useActionModalContext = (): ActionModalContextType => {
  const context = useContext(ActionModalContext)
  if (!context) {
    throw new Error('useActionModalContext must be used within an ActionModalProvider')
  }
  return context
}
